/**
 * FooterInfo - Company contact information
 *
 * Data from centralized config (lib/footerConfig.ts)
 */

import { companyInfo } from '../../lib'

const infoClass = 'text-left text-white font-poppins text-xs xl:text-sm'

export function FooterInfo() {
  return (
    <div className="flex flex-col gap-1">
      <p className={infoClass}>{companyInfo.name}</p>
      <p className={infoClass}>{companyInfo.address}</p>
      <p className={infoClass}>Telefon: {companyInfo.phone}</p>
      <p className={infoClass}>Email: {companyInfo.email}</p>
    </div>
  )
}
